module.exports = __webpack_public_path__ + "img/product1-5.3dccbe41.png";